import {emptySplitApi, providesTagsList, queryStarted} from "./api";

export const priorityApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        listPriorityPlanners: builder.query({
            query: () => ({
                url: 'priority/list',
                method: 'GET'
            }),
            providesTags: (result) => providesTagsList('PriorityPlanner', result)
        }),
        getPriorityPlanner: builder.query({
            query: (id) => `priority/${id}`,
            providesTags: (result, error, id) => [{ type: 'PriorityPlanner', id }]
        }),
        createPriorityPlanner: builder.mutation({
            query: (data) => ({
                url: 'priority/create',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [{ type: 'PriorityPlanner', id: 'LIST' }, { type: 'PriorityOrder' }]
        }),
        updatePriorityPlanner: builder.mutation({
            query: ({id, ...data}) => ({
                url: `priority/update/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getPriorityPlanner'),
            invalidatesTags: (result, error, { id }) => [{ type: 'PriorityPlanner', id }]
        }),
        deletePriorityPlanner: builder.mutation({
            query: (id) => ({
                url: `priority/delete/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: [{ type: 'PriorityPlanner', id: 'LIST' }, { type: 'PriorityTask', id: 'LIST' }]
        }),
        listPriorityTasks: builder.query({
            query: () => ({
                url: 'priority/task/list',
                method: 'GET'
            }),
            providesTags: (result) => providesTagsList('PriorityTask', result)
        }),
        getPriorityTask: builder.query({
            query: (id) => `priority/task/${id}`,
            providesTags: (result, error, id) => [{ type: 'PriorityTask', id }]
        }),
        createPriorityTask: builder.mutation({
            query: (data) => ({
                url: 'priority/task/create',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [{ type: 'PriorityTask', id: 'LIST' }]
        }),
        updatePriorityTask: builder.mutation({
            query: ({id, ...data}) => ({
                url: `priority/task/update/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getPriorityTask'),
            invalidatesTags: (result, error, { id }) => [{ type: 'PriorityTask', id }]
        }),
        deletePriorityTask: builder.mutation({
            query: (id) => ({
                url: `priority/task/delete/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: [{ type: 'PriorityTask', id: 'LIST' }]
        }),
        updatePriorityTaskStatus: builder.mutation({
            query: ({id, ...data}) => ({
                url: `priority/task/update-status/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getPriorityTask'),
            invalidatesTags: (result, error, { id }) => [{ type: 'PriorityTask', id }]
        }),
        updatePriorityTaskValue: builder.mutation({
            query: ({id, ...data}) => ({
                url: `priority/task/update-value/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getPriorityTask'),
            invalidatesTags: (result, error, { id }) => [{ type: 'PriorityTask', id }]
        }),
        updatePriorityTaskQuestions: builder.mutation({
            query: ({id, ...data}) => ({
                url: `priority/task/update-question-list/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getPriorityTask'),
            invalidatesTags: (result, error, { id }) => [{ type: 'PriorityTask', id }]
        }),
        getPriorityOrder: builder.query({
            query: () => `/priority/order`,
            providesTags: (result, error, id) => [{ type: 'PriorityOrder' }]
        }),
        updatePriorityOrder: builder.mutation({
            query: ({...data}) => ({
                url: `priority/order/update`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getPriorityOrder'),
            invalidatesTags: (result, error, { target }) => [{ type: 'PriorityOrder', target }]
        })
    })
});

export const {
    useListPriorityPlannersQuery,
    useGetPriorityPlannerQuery,
    useCreatePriorityPlannerMutation,
    useUpdatePriorityPlannerMutation,
    useDeletePriorityPlannerMutation,
    useListPriorityTasksQuery,
    useGetPriorityTaskQuery,
    useCreatePriorityTaskMutation,
    useUpdatePriorityTaskMutation,
    useDeletePriorityTaskMutation,
    useUpdatePriorityTaskStatusMutation,
    useUpdatePriorityTaskValueMutation,
    useUpdatePriorityTaskQuestionsMutation,
    useGetPriorityOrderQuery,
    useUpdatePriorityOrderMutation
} = priorityApi;